import { render, staticRenderFns } from "./NavAdminButton.vue?vue&type=template&id=029809b6&"
import script from "./NavAdminButton.vue?vue&type=script&lang=js&"
export * from "./NavAdminButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports